import { resourceManagerActions } from "../../constants/actionTypes";
import { emptyList } from "../../constants/componentConstants";

const INITIAL_STATE = {
  resourceProvidersList: { emptyList },
  resourceProvidersListPublic: { emptyList },
  connectionData: {},
  addActionData: {},
  editActionData: {},
  createTemplate: {},
  editTemplate: {},
  category: [],
  categoryInfiniteScroll: {},
  instanceInfiniteScroll: {},
  instance: [],
  templateList: { emptyList },
  template: {},
  actionData: "",
  deleteActionData: {},
  templateActionData: "",
  resourceProviderError: {},
  templateDeleteData: "",
  uploadedLogoData: {},
  uploadedLogoDataError: "",
  templatePublishData: {},
  templatePublishError: {},
  vtEnabled: "",
  vtEnabledError: "",
  resourceProviderDetails: "",
  resourceProviderDetailsError: "",
  exportTemplateData: "",
  exportTemplateError: "",
  recoverTemplateData: "",
  vmNetworkList: [],
  vmNetworkListLoading: "",
  baseVmFolderNameListLoading: "",
  cloudConnectError: false,
  cloudConnectErrorObj: {},
  cloudConnectSuccess: false,
  createTemplateError: {},
  instanceSize: {},
  instanceSizeError: {},
  deleteInstance: {},
  deleteInstanceSizeError: {},
  account_details: {
    loading: false,
    data: [],
  },
  cleaning_jobs: {
    loading: false,
    data: [],
  },
  aws_usage: {
    loading: false,
    data: [],
  },
  maintenance_session: {
    loading: false,
    data: {},
  },
  mark_as_clean: {
    loading: false,
    data: {},
  },
};

const resourceManager = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case resourceManagerActions.RESOURCE_PROVIDER_LIST_SET_DATA:
      return {
        ...state,
        resourceProvidersList: {
          ...action?.payload?.data,
        },
        actionData: "",
        templatePublishData: {},
        deleteActionData: {},
        connectionData: {},
        addActionData: {},
        editActionData: {},
        resourceProviderDetails: "",
        resourceProviderDetailsError: "",
        templateList: { emptyList },
      };
    case resourceManagerActions.RESOURCE_PROVIDER_LIST_SET_DATA_PUBLIC:
      return {
        ...state,
        resourceProvidersListPublic: {
          ...action?.payload?.data,
        },
        actionData: "",
        templatePublishData: {},
        deleteActionData: {},
        connectionData: {},
        addActionData: {},
        editActionData: {},
        resourceProviderDetails: "",
        resourceProviderDetailsError: "",
        templateList: { emptyList },
        createTemplateError: {},
        cloudConnectErrorObj: {},
      };
    case resourceManagerActions.RESOURCE_PROVIDER_LIST_SET_ERROR:
      return {
        ...state,
        actionData: action?.payload,
        resourceProvidersList: {},
        createTemplateError: {},
        cloudConnectErrorObj: {},
      };

    case resourceManagerActions.RESOURCE_PROVIDER_LIST_SET_ERROR_PUBLIC:
      return {
        ...state,
        actionData: action?.payload,
        resourceProvidersListPublic: {},
        createTemplateError: {},
      };
    case resourceManagerActions.LIST_AFTER_PATCH_PUBLIC_PROVIDER:
      const res = state?.resourceProvidersListPublic?.results?.map((item) => {
        if (item?.id === action?.payload?.id) {
          return { ...action?.payload };
        } else {
          return item;
        }
      });
      return {
        ...state,
        resourceProvidersListPublic: {
          ...state?.resourceProvidersListPublic,
          results: res,
        },
      };
    case resourceManagerActions.DELETE_RESOURCE_SUCCESS:
      return {
        ...state,
        deleteActionData: action.payload,
      };

    case resourceManagerActions.DELETE_RESOURCE_ERROR:
      return {
        ...state,
        actionData: action?.payload,
        resourceProvidersList: { ...state.resourceProvidersList },
      };

    case resourceManagerActions.TEMPLATE_CREATE_SUCCESS:
      return {
        ...state,
        createTemplate: {
          ...action.data,
        },
      };

    case resourceManagerActions.TEMPLATE_CREATE_ERROR: {
      return {
        ...state,
        createTemplateError: action?.payload,
      };
    }
    case resourceManagerActions.TEMPLATE_EDIT_SUCCESS:
      return {
        ...state,
        editTemplate: {
          ...action.data,
        },
        createTemplateError: {},
      };

    case resourceManagerActions.SET_CATEGORY_LIST_SEARCHING:
      return {
        ...state,
        categoryListSearching: action?.payload,
      };

    case resourceManagerActions.SET_INSTANCE_LIST_SEARCHING:
      return {
        ...state,
        instanceListSearching: action?.payload,
      };
    case resourceManagerActions.SET_CATEGORY_DATA:
      return {
        ...state,
        category: {
          ...action.payload,
        },
      };

    case resourceManagerActions.SET_INSTANCE_DATA_INFINITE_SCROLL: {
      const oldRes = state?.instanceInfiniteScroll?.results || [];
      return {
        ...state,
        instanceInfiniteScroll: {
          ...state?.instanceInfiniteScroll,
          ...action.payload,
          results: [...oldRes, ...action?.payload?.results],
        },
      };
    }

    case resourceManagerActions.SET_INSTANCE_SIZE_SUCESS: {
      return {
        ...state,
        instanceSize: {
          ...action.payload,
        },
      };
    }

    case resourceManagerActions.SET_INSTANCE_SIZE_ERROR: {
      return {
        ...state,
        instanceSizeError: {
          ...action.payload,
        },
      };
    }

    case resourceManagerActions.DELETE_INSTANCE_SIZE_SUCCESS: {
      return {
        ...state,
        deleteInstance: {
          ...action.payload,
        },
      };
    }

    case resourceManagerActions.DELETE_INSTANCE_SIZE_ERROR: {
      return {
        ...state,
        deleteInstanceSizeError: {
          ...action.payload,
        },
      };
    }

    case resourceManagerActions.RESET_CATEGORY_DATA_INFINITE_SCROLL: {
      return {
        ...state,
        categoryInfiniteScroll: {},
      };
    }
    case resourceManagerActions.RESET_INSTANCE_DATA_INFINITE_SCROLL: {
      return {
        ...state,
        instanceInfiniteScroll: {},
      };
    }
    case resourceManagerActions.SET_CATEGORY_DATA_INFINITE_SCROLL: {
      const oldRes = state?.categoryInfiniteScroll?.results || [];
      return {
        ...state,
        categoryInfiniteScroll: {
          ...state?.categoryInfiniteScroll,
          ...action.payload,
          results: [...oldRes, ...action?.payload?.results],
        },
      };
    }
    case resourceManagerActions.SET_INSTANCE_DATA:
      return {
        ...state,
        instance: {
          ...action.payload,
        },
      };
    case resourceManagerActions.SET_VM_SNAPSHOT_DATA:
      return {
        ...state,
        baseVmFolderNameList: action.payload?.data,
        baseVmFolderNameListLoading: false,
      };
    case resourceManagerActions.SET_VM_SNAPSHOT_ERROR:
      return {
        ...state,
        baseVmFolderNameList: [],
        baseVmFolderNameListLoading: false,
      };
    case resourceManagerActions.SET_VM_FOLDER_LIST_LOADING:
      return {
        ...state,
        baseVmFolderNameListLoading: action?.data,
      };
    case resourceManagerActions.SET_VM_NAMES_LIST:
      return {
        ...state,
        baseVmNameList: action?.data?.data,
        baseVmNameListLoading: false,
      };
    case resourceManagerActions.SET_VM_SNAPSHOT_NAMES_LIST:
      return {
        ...state,
        baseVmNameSnapshotList: action?.data?.data,
        baseVmNameSnapshotListLoading: false,
      };
    case resourceManagerActions.SET_VM_NETWORK_LIST:
      return {
        ...state,
        vmNetworkList: action?.data?.data,
        vmNetworkListLoading: false,
      };
    case resourceManagerActions.SET_VM_NETWORK_LIST_LOADING:
      return {
        ...state,
        vmNetworkListLoading: action?.data,
      };
    case resourceManagerActions.SET_VM_SNAPSHOT_NAMES_LIST_LOADING:
      return {
        ...state,
        baseVmNameSnapshotListLoading: action?.data,
      };
    case resourceManagerActions.SET_VM_NAMES_LIST_LOADING:
      return {
        ...state,
        baseVmNameListLoading: action?.data,
      };
    case resourceManagerActions.TEMPLATE_LIST_SET_DATA:
      return {
        ...state,
        templateList: {
          ...action?.payload?.data,
        },
        templateActionData: "",
        createTemplate: {},
        editTemplate: {},
        createTemplateError: {},
      };
    case resourceManagerActions.TEMPLATE_SET_DATA:
      return {
        ...state,
        template: {
          ...action?.payload?.data,
        },
        templateActionData: "",
      };
    case resourceManagerActions.TEMPLATE_LIST_SET_ERROR:
      return {
        ...state,
        templateActionData: action?.payload,
        templateList: {},
        createTemplateError: {},
      };
    case resourceManagerActions.SET_CONNECTION_DATA:
      return {
        ...state,
        connectionData: action?.payload,
      };
    case resourceManagerActions.ADD_RESOURCE_ACTION:
      return {
        ...state,
        connectionData: {},
        editActionData: {},
        addActionData: action?.payload,
      };
    case resourceManagerActions.EDIT_RESOURCE_ACTION:
      return {
        ...state,
        connectionData: {},
        addActionData: {},
        editActionData: action?.payload,
      };
    case resourceManagerActions.SET_RESOURCE_PROVIDER_ERROR:
      return {
        ...state,
        resourceProviderError: action?.payload,
      };
    case resourceManagerActions.ADD_PUBLIC_PROVIDER_SUCCESS:
      return {
        ...state,
        cloudConnectErrorObj: {},
      };
    case resourceManagerActions.ADD_PUBLIC_PROVIDER_ERROR:
      return {
        ...state,
        cloudConnectErrorObj: action?.payload,
      };
    case resourceManagerActions.DELETE_TEMPLATE_SUCCESS:
      return {
        ...state,
        templateDeleteData: action.payload,
      };
    case resourceManagerActions.SET_LOGO_DATA:
      return {
        ...state,
        uploadedLogoData: action?.payload,
      };
    case resourceManagerActions.UPLOAD_LOGO_ERROR:
      return {
        ...state,
        uploadedLogoDataError: action?.payload,
      };
    case resourceManagerActions.PUBLISH_TEMPLATE_ACTION:
      return {
        ...state,
        templateList: {},
        templatePublishData: action?.payload,
      };
    case resourceManagerActions.PUBLISH_TEMPLATE_ERROR:
      return {
        ...state,
        templatePublishError: action?.payload,
      };
    case resourceManagerActions.TOGGLE_VT_ENABLED_SUCCESS:
      return {
        ...state,
        vtEnabled: {
          ...action.payload,
        },
      };
    case resourceManagerActions.TOGGLE_VT_ENABLED_ERROR:
      return {
        ...state,
        vtEnabledError: {
          ...action.payload,
        },
      };
    case resourceManagerActions.RESOURCE_PROVIDER_SET_DETAILS:
      return {
        ...state,
        resourceProviderDetails: { ...action?.payload?.data },
      };
    case resourceManagerActions.RESOURCE_PROVIDER_SET_ERROR:
      return {
        ...state,
        resourceProviderDetailsError: action?.payload,
      };
    case resourceManagerActions.TEMPLATE_EXPORT_SUCCESS:
      return {
        ...state,
        exportTemplateData: action?.data?.data,
      };
    case resourceManagerActions.CLEAR_TEMPLATE_EXPORT:
      return {
        ...state,
        exportTemplateData: "",
      };
    case resourceManagerActions.TEMPLATE_EXPORT_ERROR:
      return {
        ...state,
        exportTemplateError: action?.data,
      };
    case resourceManagerActions.TEMPLATE_RECOVER_SUCCESS:
    case resourceManagerActions.TEMPLATE_RECOVER_ERROR:
      return {
        ...state,
        recoverTemplateData: action?.data,
      };

    case resourceManagerActions.CLOUD_CONNECT_PROVIDER_SUCCESS:
      return {
        ...state,
        cloudConnectSuccess: true,
        cloudConnectError: false,
        cloudConnectErrorObj: {},
      };
    case resourceManagerActions.CLOUD_CONNECT_PROVIDER_ERROR:
      return {
        ...state,
        cloudConnectError: true,
        cloudConnectErrorObj: action?.payload,
        cloudConnectSuccess: false,
      };
    case resourceManagerActions.SET_CLOUD_CONNECT_LOADING:
      return {
        ...state,
        cloudConnectLoading: action?.payload,
        cloudConnectError: false,
        cloudConnectSuccess: false,
      };

    // Get Account Details
    case resourceManagerActions.GET_ACCOUNT_DETAILS_ACTION: {
      return {
        ...state,
        account_details: {
          ...state?.account_details,
          loading: true,
        },
      };
    }
    case resourceManagerActions.GET_ACCOUNT_DETAILS_SUCCESS: {
      return {
        ...state,
        account_details: {
          ...state?.account_details,
          data: action?.payload?.data || [],
          loading: false,
        },
      };
    }
    case resourceManagerActions.GET_ACCOUNT_DETAILS_ERROR: {
      return {
        ...state,
        account_details: {
          ...state?.account_details,
          loading: false,
        },
      };
    }

    case resourceManagerActions.GET_ACCOUNT_DETAILS_RESET: {
      return {
        ...state,
        account_details: {
          ...state?.account_details,
          data: [],
        },
      };
    }

    // Get Cleaning Jobs

    case resourceManagerActions.GET_CLEANING_JOBS_ACTION: {
      return {
        ...state,
        cleaning_jobs: {
          ...state?.cleaning_jobs,
          loading: true,
        },
      };
    }
    case resourceManagerActions.GET_CLEANING_JOBS_SUCCESS: {
      return {
        ...state,
        cleaning_jobs: {
          ...state?.cleaning_jobs,
          data: action?.payload?.data || [],
          loading: false,
        },
      };
    }

    case resourceManagerActions.GET_CLEANING_JOBS_ERROR: {
      return {
        ...state,
        cleaning_jobs: {
          ...state?.cleaning_jobs,
          loading: false,
        },
      };
    }
    case resourceManagerActions.GET_CLEANING_JOBS_RESET: {
      return {
        ...state,
        cleaning_jobs: {
          ...state?.cleaning_jobs,
          data: [],
        },
      };
    }

    // Get AWS Usage
    case resourceManagerActions.GET_AWS_USAGE_ACTION: {
      return {
        ...state,
        aws_usage: {
          ...state?.aws_usage,
          loading: true,
        },
      };
    }
    case resourceManagerActions.GET_AWS_USAGE_SUCCESS: {
      return {
        ...state,
        aws_usage: {
          ...state?.aws_usage,
          data: action?.payload?.data || [],
          loading: false,
        },
      };
    }

    case resourceManagerActions.GET_AWS_USAGE_ERROR: {
      return {
        ...state,
        aws_usage: {
          ...state?.aws_usage,
          loading: false,
        },
      };
    }
    case resourceManagerActions.GET_AWS_USAGE_RESET: {
      return {
        ...state,
        aws_usage: {
          ...state?.aws_usage,
          data: [],
        },
      };
    }

    // Maintenance Session
    case resourceManagerActions.MAINTENANCE_SESSION_ACTION: {
      return {
        ...state,
        maintenance_session: {
          ...state?.maintenance_session,
          loading: true,
        },
      };
    }
    case resourceManagerActions.MAINTENANCE_SESSION_SUCCESS: {
      return {
        ...state,
        maintenance_session: {
          ...state?.maintenance_session,
          data: action?.payload || {},
          loading: false,
        },
      };
    }

    case resourceManagerActions.MAINTENANCE_SESSION_ERROR: {
      return {
        ...state,
        maintenance_session: {
          ...state?.maintenance_session,
          loading: false,
        },
      };
    }
    case resourceManagerActions.MAINTENANCE_SESSION_RESET: {
      return {
        ...state,
        maintenance_session: {
          ...state?.maintenance_session,
          data: {},
        },
      };
    }

    // Mark As clean
    case resourceManagerActions.MARK_AS_CLEAN_ACTION: {
      return {
        ...state,
        mark_as_clean: {
          ...state?.mark_as_clean,
          loading: true,
        },
      };
    }
    case resourceManagerActions.MARK_AS_CLEAN_SUCCESS: {
      return {
        ...state,
        mark_as_clean: {
          ...state?.mark_as_clean,
          data: action?.payload || {},
          loading: false,
        },
      };
    }

    case resourceManagerActions.MARK_AS_CLEAN_ERROR: {
      return {
        ...state,
        mark_as_clean: {
          ...state?.mark_as_clean,
          loading: false,
        },
      };
    }
    case resourceManagerActions.MARK_AS_CLEAN_RESET: {
      return {
        ...state,
        mark_as_clean: {
          ...state?.mark_as_clean,
          data: {},
        },
      };
    }

    default:
      return state;
  }
};

export default resourceManager;
